<template>
  <div>
    <div v-if="loading" class="ctx-layout-spinner" style="display: block;top: 50%;transform: translateY(-50%);"><i class="ctx-spinner"><i></i><i class="ico-ctx-loading-full"><i class="ico-ctx-loading-1"></i></i></i></div>
    <form v-if="!loading && !success && !error" @submit="onSubmit" class="form-container">
      <div class="input-group">
        <label for="emailId" class="required">Email</label>
        <input type="email" class="form-control" :placeholder="'example@domain.com'" pattern="[a-zA-Z0-9._%+\-!#$%&'*+-=?^_`~\/\{\}]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}" id="emailId" name="emailId" ref="emailId" required/>
      </div>
      <div class="btn-group">
        <button type="submit" class="btn btn-primary">Submit</button>
      </div>
    </form>
    <div class="msg-container" v-if="success || error">
      <p v-if="success">Thank you. You have successfully submitted your request to unsubscribe from email marketing. Please allow a few days for processing.</p>
      <p v-if="error">Form did not submit, please try again.</p>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Form",
  data() {
    return {
      emailId: '',
      success: false,
      error: false,
      loading: false,
      apiUrl: process.env.VUE_APP_API_URL
    };
  },
  methods: {
    onSubmit(e){
      e.preventDefault()
      this.loading = true;
      var self = this;
      this.emailId = this.$refs.emailId.value;

      const requestOptions = {
        method: 'POST',
        body: JSON.stringify({
          "emailId": this.emailId
        })    
      };

      fetch(this.apiUrl, requestOptions)
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        self.loading = false;
        self.success = true;
      })
      .catch(function () {
        self.loading = false;
        self.error = true;
      });
    }
  },
};
</script>
